import { render, staticRenderFns } from "./BoardingPassForm.vue?vue&type=template&id=5fc966b6"
import script from "./BoardingPassForm.vue?vue&type=script&lang=ts"
export * from "./BoardingPassForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports